export default __webpack_public_path__ + "static/media/road-hazards.e9832a6a.svg";